// Цена со скидкой акции для показа на витрине (П3). Тот же расчёт, что у
// шлюза (`promoCalendar.promoPrice`): проценты от цены или рубли, не ниже нуля.
// Корзину и заказ витрина по ней не считает — это делает шлюз (П2).
export const promoPrice = (price: number, type: "percent" | "amount", value: number): number => {
	const raw = type === "percent" ? price * (1 - value / 100) : price - value;
	return Math.round(Math.max(0, raw) * 100) / 100;
};

export const promoDiscountLabel = (type: "percent" | "amount", value: number): string =>
	type === "percent" ? `-${value} %` : `-${value.toLocaleString("ru-RU")} руб.`;
